import { render } from "./ProductPricing.vue?vue&type=template&id=1d8f140a&scoped=true"
import script from "./ProductPricing.vue?vue&type=script&lang=js"
export * from "./ProductPricing.vue?vue&type=script&lang=js"

import "./ProductPricing.vue?vue&type=style&index=0&id=1d8f140a&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8f140a"]])

export default __exports__